//const ADMIN = 1;
//const PRO = 2;
const CLIENT_ADMIN = 2;
const CLIENT_USER = 3;

export const commonConstants = {
  //App specifit constants
  siteName: "SmartOtis",
  siteURL: "silverethics.com",
  currencySymbol: "$",
  recordsPerPage: 20,
  dateFormat: "MM/DD/YYYY h:mma",
  //refreshPageInterval: 60*1000, //1 minute
  local_time_zone: null, //UTC to local time diff in sec

  //Regex (start)
  emailRegex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i,
  //phoneRegex: /^\([1-9]{1}[0-9]{2}\) [0-9]{3}-[0-9]{4}$/i,
  phoneRegex: /^[1-9]{1}[0-9]{9}$/i,
  whatsappRegex: /^91[1-9]{1}[0-9]{9}$/i,
  passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/,

  encryptionKey: "KeyxIPui8u9eW",
  roles: {
    client_admin: CLIENT_ADMIN,
    client_user: CLIENT_USER,
  },
  accessPaths: {
    "/dashboard$": [CLIENT_ADMIN, CLIENT_USER],
    "/sensor/[0-9]+": [CLIENT_ADMIN, CLIENT_USER],
    "/reports": [CLIENT_ADMIN, CLIENT_USER],
    "/alerts": [CLIENT_ADMIN, CLIENT_USER],
  },
  requestMethod: {
    GET: "GET",
    POST: "POST",
  },
  chartType: {
    LINE: 1,
    BAR: 2,
  },
  sensorParameter: {
    KWH: 2,
    KWHSolar: 87,
    KWHSolarImportExport: 93,
  },
  grain: {
    UNAGGREEGATED: -1,
    MIN15: 900,
    MIN30: 1800,
    MIN60: 3600,
    DAY: 86400,
  },
  stringFormatType: {
    number: "number",
    float: "float",
    phone: "phone",
    email: "email",
  },
  sensorType: {
    energy: 1,
    temperature: 2,
    solar: 6,
    solarImportExport: 7,
  },

  BLANK_LINK: "#!",

  METADATA_REQUEST: "METADATA_REQUEST",
  METADATA_SUCCESS: "METADATA_SUCCESS",
  METADATA_FAILURE: "METADATA_FAILURE",

  CITY_LISTING_REQUEST: "CITY_LISTING_REQUEST",
  CITY_LISTING_SUCCESS: "CITY_LISTING_SUCCESS",
  CITY_LISTING_FAILURE: "CITY_LISTING_FAILURE",

  DUMMY_LOADING_REQUEST: "DUMMY_LOADING_REQUEST",
  DUMMY_LOADING_COMPLETE: "DUMMY_LOADING_COMPLETE",
};
